<template>
  <div class="min-h-screen">
    <!-- <div style="height: 500px;background-size: 100% 100%;" :style="{ backgroundImage: 'url(' + require('@/assets/ygwm/about-1.png') + ')' }">
      <div style="width:1200px;padding-left: 35px;margin: 0px auto;cursor: pointer;">
        <div style="font-size: 68px;padding-top: 100px; ">全栈式数字服务伙伴</div>
        <div style="font-size: 28px;margin-top: 50px;color: #1e66d1;">从系统建设到持续增长的全周期护航</div>
      </div>
    </div> -->
    <div style="position: relative;">
      <img style="width: 100%;image-rendering: pixelated;" src="../../assets/images/about-11.png" inferSize
        alt="我们的理念" />
      <!-- <div style="width:1200px;margin: 0px auto;cursor: pointer;position: absolute;left: 0px;right: 0px;top: 80px;text-align: right;">
        <div style="font-size: 45px;">全栈式数字服务伙伴</div>
        <div style="font-size: 20px;margin-top: 30px;color: #1e66d1;">
          从系统建设到持续增长的全周期护航
        </div>
      </div> -->
    </div>
    <div class="containerb mx-auto px-4 my-12" style="margin-top: 75px;">
      <h1 style="font-size: 28px;" class="text-center">公司简介</h1>
      <div class="prose max-w-none" style="margin-top: 40px;">
        <div style="padding: 0px 35px;" id="content" v-html="aboutData.about.content" />
      </div>
    </div>
    <!-- <div class="relative my-12" style="width: 100%;margin-top: 85px;height: 932px;">
      <img style="width: 100%;" :src="require('@/assets/ygwm/about-3.png')" inferSize alt="公司历史"
        class="absolute z-0 min-w-screen h-full" />
      <div class="relative">
        <div style="font-size: 28px;text-align: center;margin-top: 20px;top: 50px;position: relative;">发展历程</div>
        <img style="max-width: auto;padding-right: 70px;margin: 0px auto;" :src="require('@/assets/ygwm/about-2.png')"
          inferSize alt="发展路线" class="object-cover" />
        <div style="width: 1200px;margin: 0px auto;position: relative;">
          <div style="margin-top: 25px;width:235px;position: absolute;left: 50px;">
            <div style="font-size:24px;color: #eb6900;">2005~2011</div>
            <div style="font-size: 26px;margin-top: 15px;">生态奠基 方案延展</div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">以腾讯通RTX业务为起点切入企业服务领域，通过即时通讯解决方案构建B端服务基础能力。</div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
              立足华中市场，围绕RTX开发插件生态（网络硬盘、消息审计等），形成“标准产品+行业定制”双轨模式，沉淀技术交付与场景适配能力。</div>
          </div>
          <div style="margin-top: 25px;width: 235px;left: 360px;top: -30px;position: absolute;">
            <div style="font-size:24px;color: #eb6900;">2012~2017</div>
            <div style="font-size: 26px;margin-top: 15px;">业务扩张 移动转型</div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">新增腾讯企业邮箱业务线，布局北京市场，构建“通讯+协同”业务矩阵，覆盖多行业场景。
            </div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
              把握移动互联网浪潮，成为首批微信企业号内测服务商，参与相关生态产品建设，成功打造出微信一体化服务平台、智慧党建云平台、高效工作流引擎等核心产品，并开发200+行业场景应用</div>
          </div>
          <div style="margin-top: 25px;width: 235px;left: 670px;top: -110px;position: absolute;">
            <div style="font-size:24px;color: #eb6900;">2018~2024</div>
            <div style="font-size: 26px;margin-top: 15px;">方案深化 交付升级</div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
              围绕企业微信、腾讯云等生态建设，成为全国性IT解决方案服务提供商，并形成“平台+应用+服务=用户价值”以客户价值为中心的服务理念
            </div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
              打造“平台+工具+运营”私域流量体系，升级数据驱动型运营服务，为客户在新的市场环境变化下创造更高的价值</div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
              累计交付800+行业定制化解决方案，深度适配金融、制造、政务等领域数字化转型需求</div>
          </div>
          <div style="margin-top: 25px;width: 235px;left: 970px;top: -300px;position: absolute;">
            <div style="font-size:24px;color: #eb6900;">2025~未来</div>
            <div style="font-size: 26px;margin-top: 15px;">智能跃迁 场景革新</div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">将大模型技术深度融入企业服务，推出智能知识库、AI客服等产品，推动客户智能化转型。
            </div>
            <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
              聚焦“AI+场景化”创新，布局AI原生应用生态，探索基于自主学习的智能服务引擎。</div>
              <div style="font-size: 14px;margin-top: 35px;text-indent: 28px;">
            我们将始终秉持“平台 + 应用 + 服务 = 用户价值”的理念，建立全生命周期服务体系，与客户建立终身数字化伙伴关系，在每一次技术变革中携手同行。</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="relative my-12" style="width: 100%;margin-top: 85px;margin-bottom: 100px;">
      <!-- <img style="width: 100%;" :src="aboutData.history.background" inferSize alt="公司历史"
        class="absolute z-0 min-w-screen h-full" /> -->
      <div class="relative">
        <img v-if="$isxj" style="max-width: auto;margin: 0px auto;" :src="aboutData.history.roadImage" inferSize
          alt="发展路线" class="object-cover" />
        <img v-else style="max-width: auto;margin: 0px auto;" :src="aboutData.history.roadImageb" inferSize
          alt="发展路线" class="object-cover" />
      </div>
    </div>
    <!-- <div style="font-size: 62px;color: #1e66d1;text-align: center;">平台+应用+服务=用户价值</div>
    <div class="relative mt-12" style="margin-top: 100px;height: 600px;margin-bottom: 50px;">
      <img style="top: 50px;" src="../../assets/ygwm/about-10.png" inferSize alt="我们的理念"
        class="h-full min-w-screen absolute z-0" />
      <h2 class="text-center relative" style="font-size:28px;">我们的理念</h2>
      <div class="containerb relative mx-auto z-10 fcc py-12" style="">
        <div class="flex" style="justify-content: space-between;padding: 0px 10px;margin-top: 150px;">
          <div class="slogan-card  -translate-x-1/2 bottom-0" style="background: #edf4fd;">
            <div class="font-bold" style="font-size:20px;color: #1e66d1;">
              3大服务平台
            </div>
            <div class="w-12 mt-2 mb-4" style="height: 3px;background: #1e66d1;"></div>
            <p>企业微信服务平台</p>
            <p>工作流引擎平台</p>
            <p>私域流量运营平台</p>
          </div>
          <div class="mx-8 slogan-text-font">
            <span>+</span>
          </div>
          <div class="slogan-card  -translate-x-1/2 bottom-0" style="background: #e3f1f0;">
            <div class="font-bold" style="font-size:20px;color: #42a638;">
              200+应用积累
            </div>
            <div class="w-12 mt-2 mb-4" style="height: 3px;background: #42a638;"></div>
            <p>智慧校园</p>
            <p>智慧零售</p>
            <p>移动办公</p>
            <p>......</p>
          </div>
          <div class="mx-8 slogan-text-font">
            <span>+</span>
          </div>
          <div class="slogan-card  -translate-x-1/2 bottom-0" style="background: #fdf6f1;">
            <div class="font-bold" style="font-size:20px;color: #f88031;">
              300+专业服务
            </div>
            <div class="w-12 mt-2 mb-4" style="height: 3px;background: #f88031;"></div>
            <p>官方授权服务商</p>
            <p>售前支持</p>
            <p>技术研发</p>
            <p>售后服务</p>
          </div>
          <div class="mx-8 slogan-text-font">
            <span>=</span>
          </div>
          <div class="slogan-card" style="background: #f6f6f6;">
            <div class="font-bold" style="font-size:20px;">为2000+客户</div>
            <div class="w-12 mt-2 mb-4" style="height: 3px;background: #666;"></div>
            <p>提供专业的</p>
            <p>移动互联网</p>
            <p>+解决方案</p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="relative" style="height: 640px;background: #f6f6f6;">
      <img :src="aboutData.serviceBackground" inferSize alt="我们的服务" class="h-full min-w-screen absolute z-0"
        style="width: 100%;opacity: 0.1;position: absolute;" />
      <div class="relative z-10 fcc pt-12 pb-20 bg-white/80" style="padding-top: 60px;">
        <div class="containerb" style="margin: 0px auto;">
          <h2 class="mb-8 text-center" style="font-size:28px;margin-bottom: 50px;">我们的服务</h2>
          <div style="display: flex;justify-content: space-around;">
            <div style="text-align: center;">
              <div>
                <img src="../../assets/ygwm/about-4.png" style="margin: 0px auto;">
              </div>
              <div style="font-size: 24px;font-weight: bold;margin-top: 18px;">专业、完整的信息化解决方案</div>
              <div style="font-size: 14px;margin-top: 30px;width: 327px;">凭借高研发投入和丰富项目经验，为客户提供以业务需求为核心的专业信息化解决方案。</div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 35px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>场景驱动分析</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>需求诊断</div>
                </div>
              </div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 10px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>解决方案设计</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>可行性分析</div>
                </div>
              </div>
            </div>
            <div style="text-align: center;">
              <div>
                <img src="../../assets/ygwm/about-5.png" style="margin: 0px auto;">
              </div>
              <div style="font-size: 24px;font-weight: bold;margin-top: 18px;">先进、高效的技术支持</div>
              <div style="font-size: 14px;margin-top: 30px;width: 327px;">汇聚行业优秀人才，持续深耕前沿技术与创新应用，为客户提供高效、专业的技术支持。</div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 35px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>系统部署优化</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>性能调优</div>
                </div>
              </div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 10px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>产品培训</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>上线推广</div>
                </div>
              </div>
            </div>
            <div style="text-align: center;">
              <div>
                <img src="../../assets/ygwm/about-6.png" style="margin: 0px auto;">
              </div>
              <div style="font-size: 24px;font-weight: bold;margin-top: 18px;">快捷、优质的售后服务</div>
              <div style="font-size: 14px;margin-top: 30px;width: 327px;">提供快速响应、精准高效的售后服务，以专业方案有效解决您的后顾之忧。</div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 35px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>7x24小时运维</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>15分钟应急响应</div>
                </div>
              </div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 10px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>定期健康巡检</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>优化建议</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="relative" style="height: 640px;background-color: #1e66d1;">
      <img :src="aboutData.serviceBackground" inferSize alt="我们的服务" class="h-full min-w-screen absolute z-0"
        style="width: 100%;opacity: 0.1;position: absolute;" />
      <div class="relative z-10 fcc pt-12 pb-20 bg-white/80" style="padding-top: 80px;">
        <div class="containerb" style="margin: 0px auto;">
          <h2 class="mb-8 text-center" style="font-size:28px;margin-bottom: 50px;color: #fff;">我们的服务</h2>
          <div style="color:#fff;display: flex;justify-content: space-around;">
            <div style="text-align: center;">
              <div>
                <img src="../../assets/ygwm/about-4.png" style="margin: 0px auto;">
              </div>
              <div style="font-size: 24px;font-weight: bold;margin-top: 18px;">专业、完整的信息化解决方案</div>
              <div style="font-size: 14px;margin-top: 30px;width: 327px;">凭借高研发投入和丰富项目经验，为客户提供以业务需求为核心的专业信息化解决方案。</div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 35px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>场景驱动分析</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>需求诊断</div>
                </div>
              </div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 10px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>解决方案设计</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>可行性分析</div>
                </div>
              </div>
            </div>
            <div style="text-align: center;">
              <div>
                <img src="../../assets/ygwm/about-5.png" style="margin: 0px auto;">
              </div>
              <div style="font-size: 24px;font-weight: bold;margin-top: 18px;">先进、高效的技术支持</div>
              <div style="font-size: 14px;margin-top: 30px;width: 327px;">汇聚行业优秀人才，持续深耕前沿技术与创新应用，为客户提供高效、专业的技术支持。</div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 35px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>系统部署优化</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>性能调优</div>
                </div>
              </div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 10px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>产品培训</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>上线推广</div>
                </div>
              </div>
            </div>
            <div style="text-align: center;">
              <div>
                <img src="../../assets/ygwm/about-6.png" style="margin: 0px auto;">
              </div>
              <div style="font-size: 24px;font-weight: bold;margin-top: 18px;">快捷、优质的售后服务</div>
              <div style="font-size: 14px;margin-top: 30px;width: 327px;">提供快速响应、精准高效的售后服务，以专业方案有效解决您的后顾之忧。</div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 35px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>7x24小时运维</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>15分钟应急响应</div>
                </div>
              </div>
              <div style="font-size: 14px;display: flex;color: #333;margin-top: 10px;justify-content: center;">
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>定期健康巡检</div>
                </div>
                <div
                  style="display: flex;align-items: center;width: 140px;height: 36px;background: #fff;border-radius: 5px;justify-content: center;margin-left: 10px;">
                  <div><img src="../../assets/ygwm/about-7.png"></div>
                  <div>优化建议</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="relative" style="height: 650px;">
      <img src="../../assets/ygwm/about-8.png" inferSize alt="我们的理念" class="h-full min-w-screen absolute z-0" />
      <div style="position: relative;font-size: 28px;text-align: center;top: 50px;">
        服务流程
      </div>
      <div style="position: relative;top: 80px;">
        <img src="../../assets/ygwm/about-9.png" style="margin: 0px auto;" />
      </div>
    </div> -->
    <!-- <div style="height: 80px;"></div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      Arrow1: require("../../assets/about/arrow1.png"),
      Arrow2: require("../../assets/about/arrow2.png"),
      aboutData: {
        heroImage: require("../../assets/images/ny-bannar2.jpg"),
        about: {
          title: "公司简介",
          content: `有限公司是一家面向全国的IT解决方案与服务提供商。自成立起，即作为腾讯企业级产品的核心服务商，专注于腾讯企业产品的落地实施，致力于打通各种应用场景，提供包括咨询、规划、开发集成、实施部署、运营推广及售后维护的全方位综合性解决方案。</p>
    <p>凭借在多个行业的深厚积累与洞察， 我们成功构建了覆盖教育、制造、科研设计、零售连锁、政府机构、金融、能源等多个行业的成熟解决方案体系，市场占有率持续领先。在长期服务企业的过程中，我们逐渐形成了“平台+应用+服务=用户价值”的核心理念，并围绕此理念打造了企业微信服务平台、工作流引擎平台、私域流量运营平台等三大平台，以及200多个涉及智慧校园、移动办公、数字政务、企业文化、资讯通知、AI工具集成等类型的应用，帮助上千家企业实现了智能化、移动化的高效工作方式。</p>
    <p>未来，我们将聚焦AI技术与企业服务的深度融合，以“大模型+行业知识库+智能应用”，构建企业智能中枢，通过智能客服、知识管理、信息安全等解决方案，赋能企业构建智慧运营体系，释放数据资产价值。在AI时代，驱动企业智能化转型，让AI成为增长新引擎。</p>    
          `,
        },
        history: {
          background: require("../../assets/images/about/历程背景.png"),
          roadImage: require("../../assets/images/about-12.png"),
          roadImageb: require("../../assets/images/about_13.jpg"),
        },
        sloganBackground: require("../../assets/images/about/1.png"),
        serviceBackground: require("../../assets/images/xzwm4.jpg"),
      }
    }
  },
  created(){
    if(this.$isxj)this.aboutData.about.content = '<p>武汉讯捷信息技术'+this.aboutData.about.content
      else this.aboutData.about.content = '<p>北京畅邮空间信息技术'+this.aboutData.about.content
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style scoped>
.slogan-text-font {
  font-size: 36px;
  display: flex;
  align-items: center;
}

.slogan-detail-card-title {
  font-size: 20px;
  display: relative;
}

.slogan-card {
  color: var(--color-content1);
  display: flex;
  height: 250px;
  width: 200px;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;
  background-color: rgb(255 255 255 / 0.8);
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-size: 0.875rem;
  line-height: 1.75rem;
}

::v-deep #content p {
  text-indent: 2em;
  line-height: 35px;
  font-size: 16px;
}

::v-deep #content p:nth-child(2) {
  margin-top: 35px;
}

::v-deep #content p:nth-child(3) {
  margin-top: 35px;
}

/* img{
  width:100%;
  height:100%;
} */
</style>
